import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ProductListing from "@/components/ProductListing";
import { ChevronLeft } from "lucide-react";

export default function SearchResultsPage() {
  const { q } = useParams();
  const term = decodeURIComponent(q || "");
  const navigate = useNavigate();

  useEffect(() => { window.scrollTo(0, 0); }, [term]);

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Header />
      <section className="bg-steel text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <button onClick={() => navigate("/")} className="flex items-center gap-1 text-sm text-slate-300 hover:text-accent mb-3">
            <ChevronLeft size={16} /> Back to catalog
          </button>
          <span className="text-xs font-mono tracking-[0.3em] text-accent">SEARCH RESULTS</span>
          <h1 className="mt-2 text-3xl sm:text-4xl font-extrabold" data-testid="search-heading">“{term}”</h1>
        </div>
      </section>
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 w-full flex-1">
        <ProductListing params={{ q: term }} withBrands testid="search" noun="result"
          empty={<div className="text-center py-20">
            <p className="text-muted-foreground">No products match “{term}”.</p>
            <button onClick={() => navigate("/")} className="mt-4 text-accent hover:underline">Browse all products →</button>
          </div>} />
      </main>
      <Footer />
    </div>
  );
}
